export default {"src":"/_next/static/media/Myorders.1e2fd585.svg","height":84,"width":84,"blurWidth":0,"blurHeight":0};